<template>
  <div class="mv-bg-main">
      <el-card >
        <div slot="header" class="clearfix">
          <span>查询条件</span>
        </div>
        <el-row>
          <el-form :inline="true" ref="searchForm" :model="formInline" label-width="100px" class="demo-form-inline">
            <el-form-item label="业务系统" prop="value8">
              <el-select v-model="formInline.value8" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in formInline.options"
                  :key="item.systemId"
                  :label="item.systemName"
                  :value="item.systemId" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商名称" prop="input">
              <el-input v-model="formInline.input" clearable placeholder="请输入供应商名称"></el-input>
            </el-form-item>
            <el-form-item label="服务状态" prop="cusState">
              <el-select v-model="formInline.cusState" clearable filterable placeholder="请选择">
                <el-option
                  v-for="item in formInline.states"
                  :key="item.state"
                  :label="item.state"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务名称" prop="cusInput">
              <el-input v-model="formInline.cusInput" clearable placeholder="请输入服务名称"></el-input>
            </el-form-item>
            <el-form-item label="创建时间" prop="value1">
              <el-date-picker
                v-model="formInline.value1"
                :editable = "bol"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="float-r">
              <el-button size="small" @click="onReset('searchForm')">重置</el-button>
              <el-button size="small" type="primary" @click="queryAll" >查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </el-card>
      <el-card class="m-top">
          <div slot="header" class="clearfix">
            <span class="card-title">查询结果</span>
            <!-- <el-button type="primary" size="small" style="float: right; margin-top: -10px;" icon="el-icon-delete" @click="moreDelete"></el-button> -->
            <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button>
          </div>
          <el-table
            :data="tableData"
            @selection-change="changeFun"
            style="width: 100%"
            >
            <!-- <el-table-column
              type="selection"
              fixed="left"
              @selection-change="changeFun"
              width="55">
            </el-table-column> -->
            <el-table-column
              label="业务系统名称"
              :show-overflow-tooltip="tooltip"
              width="180">
              <template slot-scope="scope">
                <span >{{ scope.row.sysName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="tooltip"
              label="供应商简称">
              <template slot-scope="scope">
                <span >{{ scope.row.supShortName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="服务名称" :show-overflow-tooltip="tooltip" width="240">
              <template slot-scope="scope">
                <span class="link" @click="detailSuper(scope.$index, scope.row)">{{ scope.row.supServiceName }}</span>
                <!-- <span >{{ scope.row.supServiceName }}</span> -->
              </template>
            </el-table-column>
            <el-table-column
              label="服务状态" :show-overflow-tooltip="tooltip">
              <template slot-scope="scope">
                <span >{{ scope.row.state === 1 ? '启用': '停用' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="计价策略" :show-overflow-tooltip="tooltip">
              <template slot-scope="scope">
                <span >{{ scope.row.strategyName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="服务超时时间(秒)" :show-overflow-tooltip="tooltip">
              <template slot-scope="scope">
                <span >{{ scope.row.timeOut }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="默认价格(元)" :show-overflow-tooltip="tooltip">
              <template slot-scope="scope">
                <span >{{ scope.row.supServiceGuidedPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="计价字段" :show-overflow-tooltip="tooltip">
              <template slot-scope="scope" :show-overflow-tooltip="tooltip">
                <span >{{ scope.row.billKeyWord }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间" width='170' :show-overflow-tooltip="tooltip">
              <template slot-scope="scope">
                <span >{{ scope.row.createTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            class="mt center"
            @size-change="handleSizeChange"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="page"
            layout="total, sizes, prev, pager, next"
            :total="total">
          </el-pagination>
      </el-card>
      <el-dialog  @close="close" :title="title" width="850px"   center  :modal-append-to-body='false'  :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <h2 class="refund-dialog-title">基本信息</h2>
          <el-row>
            <el-col :span="12">
              <el-form-item label="业务系统:" prop="sysId" :required="mask"  :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-if="editSure" :sysId="form.sysId" v-model="form.sysName" :disabled="disabled" auto-complete="off"></el-input>
                <el-select v-if="!editSure" @change="selectSys" v-model="form.sysId" filterable  placeholder="请选择业务系统">
                  <el-option   :label="item.systemName" :value="item.systemId" v-for="(item, $index) in form.busSystem" :key="$index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="供应商全称:" prop="supId" :required="mask"  :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-if="editSure" :supId="form.supId" v-model="form.supName" :disabled="disabled" auto-complete="off"></el-input>
                <el-select v-if="!editSure" @change="selectSup" filterable  v-model="form.supId" placeholder="请选择供应商">
                  <el-option  :label="item.supName" :value="item.supId" v-for="(item, $index) in form.supplier" :key="$index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="供应商简称:" prop="shortName" :required="mask"  :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-if="editSure" v-model="form.shortName" :disabled="disabled" auto-complete="off"></el-input>
                <el-select v-if="!editSure" @change="selectSupShort" filterable  v-model="form.supId" placeholder="请选择供应商简称">
                  <el-option  :label="item.supShortName" :value="item.supId" v-for="(item, $index) in form.supplier" :key="$index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="扣费账户:" prop="accId" :required="mask" :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-show="editSure" :accId="form.accId" v-model="form.acctName" :disabled="disabled" auto-complete="off"></el-input>
                <el-select v-show="!editSure" filterable  v-model="form.accId" placeholder="请选择账户">
                  <el-option @click.native="selectAccount(item)" :label="item.supAccountName" :value="item.supAccountId" v-for="(item, $index) in form.account" :key="$index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务名称:" prop="cusName" :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-model="form.cusName" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item  label="服务英文名称:" prop="cusEngName" :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-model="form.cusEngName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务超时时间:" prop="cusTime" :label-width="formLabelWidth">
                <el-input style="width: 217px;" maxlength="9" v-model="form.cusTime" auto-complete="off"></el-input>
                <span>(ms)</span>
              </el-form-item>
              <el-form-item label="服务指导价格:" prop="cusPrice" :label-width="formLabelWidth">
                <el-input style="width: 217px;" maxlength="10" v-model="form.cusPrice" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="服务地址:" :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-model="form.cusAdress" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="服务内网地址:" :label-width="formLabelWidth">
                <el-input style="width: 217px;" v-model="form.cusTest" auto-complete="off"></el-input>
              </el-form-item>
              <el-form-item label="请求方法:" :label-width="formLabelWidth">
                <el-select v-model="form.reqMethod" placeholder="请选择请求方法">
                  <el-option label="GET" value="1"></el-option>
                  <el-option label="POST" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务状态:" :label-width="formLabelWidth">
                <el-select v-model="form.cusState" placeholder="请选择服务状态">
                  <el-option label="启用" value="1"></el-option>
                  <el-option label="停用" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <h2 class="refund-dialog-title">计价信息</h2>
          <Rule v-on:reduceBill="reduceBill" v-on:addBill = "addBill" v-for="(item, $index) in loopRule" :key="$index" :add="item.add" :billArr="item.billArr" v-on:switchRule="getBill($event, $index)" :strategy="item.strategy" :priciRule="item.priciRule" v-on:switchStr="getRule($event, $index)" :form="item"></Rule>
          <el-form-item style="textAlign: center;">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-show="editSure">确 定</el-button>
            <el-button type="primary" @click="addForm('ruleForm')" v-show="!editSure">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog  title="供应商服务详情"  width="850px" center :modal-append-to-body='false' :visible.sync="detailDialog">
        <el-form :model="detailInfo"  ref="detailInfo">
          <h2 class="refund-dialog-title">基本信息</h2>
          <el-col :span="12">
            <el-form-item label="业务系统:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.sysName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="供应商全称:"  :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.supName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="供应商简称:"  :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled  maxlength="30" clearable v-model="detailInfo.supShortName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="扣费账户:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.supAccountName" ></el-input>
            </el-form-item>
            <el-form-item label="服务名称:"  :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.supServiceName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="服务英文名称:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.supServiceEnName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务超时时间:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.timeOut" auto-complete="off"></el-input>
              <span>(ms)</span>
            </el-form-item>
            <el-form-item label="服务指导价格:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.supServiceGuidedPrice" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="服务地址:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.supServiceUrl" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="服务内网地址:"   :label-width="formLabelWidth">
              <el-input style="width: 217px;" disabled maxlength="30" clearable v-model="detailInfo.innerUrl" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="服务请求方法:"   :label-width="formLabelWidth">
              <el-select disabled v-model="detailInfo.supServiceMethod" placeholder="请选择请求方法">
                <el-option label="GET" value="1"></el-option>
                <el-option label="POST" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务状态:"   :label-width="formLabelWidth">
              <el-select disabled v-model="detailInfo.state" placeholder="请选择服务状态">
                <el-option label="启用" value="1"></el-option>
                <el-option label="停用" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <h2 class="refund-dialog-title">计价信息</h2>
          <div v-for="(item, index) in detailData" :key="index" class="clearfix">
            <el-form-item
              label="计价策略:"
              :label-width="formLabelWidth"
            >
              <el-input style="width: 217px;" disabled  v-model="item.strategyName" ></el-input>
            </el-form-item>
            <el-form-item
              label="计价规则:"
              :label-width="formLabelWidth"
            >
              <el-input style="width: 217px;" disabled  v-model="item.ruleName" ></el-input>
            </el-form-item>
            <el-form-item
              label="规则生效时间:"
              :label-width="formLabelWidth"
            >
              <el-input style="width: 217px;" disabled  v-model="item.date" ></el-input>
            </el-form-item>
            <el-form-item label="计费字段:" :label-width="formLabelWidth"  v-for="(item, $index) in item.billArr" :key="$index">
              <el-input style="width: 217px;" disabled v-model="item.billKeyWord"></el-input>
              <el-input style="width: 217px;" disabled class="ml" v-model="item.billParamName"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
</style>
<script>
import { mapState } from 'vuex'
import Rule from './rule/Rule.vue'
export default {
  name: 'Supper',
  data () {
    return {
      loopRule: [
        {
          add: true,
          strategy: [],
          priciRule: [],
          strategyName: '',
          strategyId: '',
          disabled: false,
          rule: '',
          ruleName: '',
          date: '',
          billArr: [
            {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
          ]
        }
      ],
      detailData: [
        {
          strategy: [],
          priciRule: [],
          strategyName: '',
          ruleName: '',
          date: '',
          billArr: [
            {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
          ]
        }
      ],
      detailInfo: {
        sysName: '',
        supName: '',
        supShortName: '',
        supServiceName: '',
        supServiceEnName: '',
        timeOut: '',
        supServiceGuidedPrice: '',
        supServiceUrl: '',
        innerUrl: '',
        supServiceMethod: '',
        state: '',
        supAccountName: ''
      },
      entryTime: '', // 生效时间
      detailDialog: false,
      tooltip: true,
      supServiceId: '',
      supArr: [],
      add: true,
      editSure: null,
      title: '',
      value14: '',
      mask: true,
      modalClick: false,
      dialogVisible: false,
      form: {
        cusState: '1',
        reqMethod: '1',
        cusTest: '',
        cusAdress: '',
        cusPrice: '',
        cusTime: '',
        cusEngName: '',
        cusName: '',
        acctName: '',
        shortName: '',
        sysName: '',
        supName: '',
        supId: '',
        accId: '',
        sysId: '',
        busSystem: [],
        supplier: [],
        account: [],
        supServiceChargeRefIdList: ''
      },
      disabled: true,
      rules: {
        cusName: [
          { required: true, message: '请输入服务名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: 'blur' }
        ],
        sysId: [
          { required: true, message: '请选取业务系统', trigger: 'change' }
        ],
        supId: [
          { required: true, message: '请选取供应商名称', trigger: 'change' }
        ],
        shortName: [
          { required: true, message: '请选取供应商简称', trigger: 'change' }
        ],
        accId: [
          { required: true, message: '请选取扣费账户', trigger: 'change' }
        ],
        cusEngName: [
          { required: true, message: '请输入服务英文名称', trigger: 'blur' },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ],
        cusTime: [
          { required: true, message: '请输入服务超时时间', trigger: 'blur' },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        cusPrice: [
          { required: true, message: '请输入服务指导价格', trigger: 'blur' },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ]
      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
      formInline: {
        options: null,
        value8: '',
        input: '',
        value1: '',
        cusInput: '',
        cusState: '',
        states: [
          { state: '全部', 'id': -2 },
          { state: '启用', 'id': 1 },
          { state: '停用', 'id': 0 }
        ]
      },
      bol: false,
      systemId: '',
      currentPage4: 1,
      page: 10
    }
  },
  computed: {
    ...mapState('super', {
      tableData: state => state.table,
      total: state => state.total
    })
  },
  methods: {
    reset () {
      this.formInline.value8 = ''
      this.formInline.input = ''
      this.formInline.value1 = ''
      this.formInline.cusInput = ''
      this.formInline.cusState = ''
    },
    submitForm (formName) { // 编辑保存服务
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.loopRule)
          for (let v of this.loopRule) {
            if (!v.strategyId) {
              this.$message.error('请选择计价策略!')
              return
            }
            if (!v.date) {
              this.$message.error('请选择计价规则生效时间!')
              return
            }
          }
          let refList = []
          let refBillKeyWordsList = []
          for (let v of this.loopRule) {
            let op = {}
            op.strategyName = v.strategyName
            op.ruleName = v.ruleName
            op.ruleId = v.rule
            op.beginTime = v.date
            refList.push(op)
            let id = v.rule
            for (let e of v.billArr) {
              let obj = {}
              obj.ruleId = id
              obj.billKeyWord = e.billKeyWord
              obj.billKeyWordType = e.billKeyWordType
              refBillKeyWordsList.push(obj)
            }
          }
          console.log(refList)
          console.log(refBillKeyWordsList)
          let subOp = { // 提交数据
            sysId: this.form.sysId,
            sysName: this.form.sysName,
            supId: this.form.supId,
            supServiceId: this.supServiceId,
            supName: this.form.supName,
            supShortName: this.form.shortName,
            supServiceName: this.form.cusName,
            supServiceEnName: this.form.cusEngName,
            timeOut: this.form.cusTime,
            supServiceGuidedPrice: this.form.cusPrice,
            supServiceUrl: this.form.cusAdress,
            innerUrl: this.form.cusTest,
            supServiceMethod: this.form.reqMethod,
            state: this.form.cusState,
            supAccountId: this.form.accId,
            supAccountName: this.form.acctName,
            refList: refList,
            refBillKeyWordsList: refBillKeyWordsList,
            supServiceChargeRefIdList: this.supServiceChargeRefIdList
          }
          console.log(subOp)
          for (let i = 0; i < refBillKeyWordsList.length; i++) {
            for (let j = i + 1; j < refBillKeyWordsList.length; j++) {
              if (JSON.stringify(refBillKeyWordsList[i]) === JSON.stringify(refBillKeyWordsList[j])) {
                this.$message.error('计费字段不能相同!')
                return
              }
            }
          }
          if (this.loopRule.length > 1) {
            if (this.loopRule[0].rule === this.loopRule[1].rule) {
              this.$message.error('计价规则不能相同!')
              return
            }
            if (this.loopRule[0].date === this.loopRule[1].date) {
              this.$message.error('计价规则生效时间不能相同!')
              return
            }
            let dataOne = new Date(this.loopRule[0].date).getTime()
            let dataTwo = new Date(this.loopRule[1].date).getTime()
            if (this.entryTime) {
              if (dataOne < new Date(this.entryTime).getTime() || dataTwo < new Date(this.entryTime).getTime()) {
                this.$message.error('生效时间不能选择在' + this.entryTime + '之前！')
                return
              }
            } else {
              if (dataOne < new Date().getTime() || dataTwo < new Date().getTime()) {
                this.$message.error('生效时间不能选择在当前时间之前！')
                return
              }
            }
            let data = Math.abs(dataOne - dataTwo)
            if (data < (5 * 60 * 1000)) {
              this.$message.error('两个时间不能选取在 5 分钟之内！')
              return
            }
          } else {
            let dataOne = new Date(this.loopRule[0].date).getTime()
            if (this.entryTime) {
              if (dataOne < new Date(this.entryTime).getTime()) {
                this.$message.error('生效时间不能选择在' + this.entryTime + '之前！')
                return
              }
            } else {
              if (dataOne < new Date().getTime()) {
                this.$message.error('生效时间不能选择在当前时间之前！')
                return
              }
            }
          }
          this.$axios({
            method: 'post',
            url: _this.$API.supplier.updateSupServiceInfo,
            data: subOp
          }).then((response) => {
            _this.$message.success('服务更新成功!')
            _this.dialogFormVisible = false
            _this.query()
          }).catch((err) => {
            console.log(err)
          })
          console.log('ss')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addForm (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.loopRule)
          for (let v of this.loopRule) {
            if (!v.strategyId) {
              this.$message.error('请选择计价策略!')
              return
            }
            if (!v.date) {
              this.$message.error('请选择计价规则生效时间!')
              return
            }
          }
          let refList = []
          let refBillKeyWordsList = []
          for (let v of this.loopRule) {
            let op = {}
            op.strategyName = v.strategyName
            op.ruleName = v.ruleName
            op.ruleId = v.rule
            op.beginTime = v.date
            refList.push(op)
            let id = v.rule
            for (let e of v.billArr) {
              let obj = {}
              obj.ruleId = id
              obj.billKeyWord = e.billKeyWord
              obj.billKeyWordType = e.billKeyWordType
              refBillKeyWordsList.push(obj)
            }
          }
          console.log(refList)
          console.log(refBillKeyWordsList)
          let subOp = { // 提交数据
            sysId: this.form.sysId,
            sysName: this.form.sysName,
            supId: this.form.supId,
            supName: this.form.supName,
            supShortName: this.form.shortName,
            supServiceName: this.form.cusName,
            supServiceEnName: this.form.cusEngName,
            timeOut: this.form.cusTime,
            supServiceGuidedPrice: this.form.cusPrice,
            supServiceUrl: this.form.cusAdress,
            innerUrl: this.form.cusTest,
            supServiceMethod: this.form.reqMethod,
            state: this.form.cusState,
            supAccountId: this.form.accId,
            supAccountName: this.form.acctName,
            refList: refList,
            refBillKeyWordsList: refBillKeyWordsList
          }
          console.log(subOp)
          for (let i = 0; i < refBillKeyWordsList.length; i++) {
            for (let j = i + 1; j < refBillKeyWordsList.length; j++) {
              if (JSON.stringify(refBillKeyWordsList[i]) === JSON.stringify(refBillKeyWordsList[j])) {
                this.$message.error('计费字段不能相同!')
                return
              }
            }
          }
          if (this.loopRule.length > 1) {
            if (this.loopRule[0].rule === this.loopRule[1].rule) {
              this.$message.error('计价规则不能相同!')
              return
            }
            if (this.loopRule[0].date === this.loopRule[1].date) {
              this.$message.error('计价规则生效时间不能相同!')
              return
            }
            let dataOne = new Date(this.loopRule[0].date).getTime()
            let dataTwo = new Date(this.loopRule[1].date).getTime()
            let data = Math.abs(dataOne - dataTwo)
            if (dataOne < new Date().getTime() || dataTwo < new Date().getTime()) {
              this.$message.error('生效时间不能选择在当前时间之前！')
              return
            }
            if (data < (5 * 60 * 1000)) {
              this.$message.error('两个时间不能选取在 5 分钟之内！')
              return
            }
          } else {
            let dataOne = new Date(this.loopRule[0].date).getTime()
            if (dataOne < new Date().getTime()) {
              this.$message.error('生效时间不能选择在当前时间之前！')
              return
            }
          }
          this.$axios({
            method: 'post',
            url: _this.$API.supplier.addSupServiceInfo,
            data: subOp
          }).then((response) => {
            _this.$message.success('服务新增成功!')
            _this.dialogFormVisible = false
            _this.query()
          }).catch((err) => {
            console.log(err)
          })
          console.log('ss')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage4 = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage4 = val
      this.query()
    },
    queryAll () {
      this.currentPage4 = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      console.log(this.formInline)
      this.$refs[formName].resetFields()
      this.formInline.value8 = ''
      this.formInline.input = ''
      this.formInline.value1 = ''
      this.formInline.cusInput = ''
      this.formInline.cusState = ''
    },
    addBill () { // 增加计价信息
      if (this.loopRule.length === 2) {
        this.$message.warning('最多只能增加两条计价规则')
        return
      }
      let obj = Object.assign({}, this.loopRule[0])
      // 清空之前部分的信息
      obj.add = false
      obj.priciRule = []
      obj.strategyName = ''
      obj.rule = ''
      obj.ruleName = ''
      obj.strategyId = ''
      obj.date = ''
      obj.disabled = false
      obj.billArr = [
        {
          billKeyWord: '',
          billParamName: '',
          billKeyWordType: ''
        }
      ]
      if (this.loopRule[0].strategyId === '20171020110707_Yr2r1x61_1000005') {
        obj.billArr = []
      }
      this.loopRule.push(obj)
    },
    reduceBill () { // 减少计价信息
      if (this.loopRule.length === 2 && this.loopRule[1].disabled) return
      this.loopRule.pop()
    },
    getRule (op, index) { // 获取计价规则
      let _this = this
      _this.loopRule[index].strategyName = op.strategyName
      let obj = {}
      obj.strategyId = op.strategyId
      obj.targetType = '0'
      obj.sysId = this.form.sysId
      this.$axios({
        method: 'get',
        params: obj,
        url: _this.$API.product.queryRuleUnusedByStrategyId
      }).then((response) => {
        _this.loopRule[index].priciRule = response.data.resData
        _this.loopRule[index].rule = ''
        _this.loopRule[index].ruleName = ''
        _this.loopRule[index].billArr = [
          {
            billKeyWord: '',
            billParamName: '',
            billKeyWordType: ''
          }
        ]
        if (op.strategyId === '20171020110707_Yr2r1x61_1000005') {
          _this.loopRule[index].billArr = []
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getBill (op, index) { // 获取计价字段
      let _this = this
      _this.loopRule[index].ruleName = op.ruleNameCn
      console.log(_this.loopRule)
      this.$axios({
        method: 'get',
        url: _this.$API.product.queryInterfaceParamInfoByAll
      }).then((response) => {
        if (!op.ruleFields) return
        _this.loopRule[index].billArr = []
        for (var v of op.ruleFields) {
          let obj = {}
          obj.billKeyWord = ''
          obj.billParamName = ''
          obj.billKeyWordType = ''
          for (var val of response.data.resData.paramNameList) {
            if (v.key === val.paramIdentify) {
              obj.billParamName = val.paramName
              obj.billKeyWordType = val.interfaceParamId
              obj.billKeyWord = ''
            }
          }
          _this.loopRule[index].billArr.push(obj)
        }
        if (!_this.loopRule[index].billArr.length) {
          _this.loopRule[index].billArr = [
            {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
          ]
        }
        if (this.loopRule[index].strategyId === '20171020110707_Yr2r1x61_1000005') {
          _this.loopRule[index].billArr = []
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    selectSys (value) {
      let id = value
      for (let v of this.form.busSystem) {
        if (v.systemId === value) {
          this.form.sysName = v.systemName
        }
      }
      console.log(id)
      this.form.supId = '' // 每次选取时重新清空之前选择的值
      this.form.supName = ''
      this.form.shortName = ''
      this.form.accId = ''
      this.form.acctName = ''
      let _this = this
      this.$axios({ // 查询供应商
        method: 'post',
        url: _this.$API.supplier.querySupInfoAllBySysId,
        data: { sysId: id }
      }).then((response) => {
        if (response && response.data) {
          _this.form.supplier = response.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    selectSupShort (value) {
      let id = value
      for (let v of this.form.supplier) {
        if (v.supId === value) {
          this.form.supName = v.supName
          this.form.shortName = v.supShortName
        }
      }
      // this.form.supName = item.supName
      // this.form.shortName = item.supShortName
      this.form.accId = ''
      this.form.acctName = ''
      let _this = this
      this.$axios({ // 查询账户信息
        method: 'get',
        url: _this.$API.supplier.queryAccountBySupId,
        params: { supId: id }
      }).then((reponse) => {
        if (reponse && reponse.data) {
          _this.form.account = reponse.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    selectSup (value) {
      let id = value
      for (let v of this.form.supplier) {
        if (v.supId === value) {
          this.form.supName = v.supName
          this.form.shortName = v.supShortName
        }
      }
      this.form.accId = ''
      this.form.acctName = ''
      let _this = this
      this.$axios({ // 查询账户信息
        method: 'get',
        url: _this.$API.supplier.queryAccountBySupId,
        params: { supId: id }
      }).then((reponse) => {
        if (reponse && reponse.data) {
          _this.form.account = reponse.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    selectAccount (item) {
      this.form.acctName = item.supAccountName
    },
    handleEdit (index, val) { // 服务编辑
      this.supServiceId = val.supServiceId
      this.title = '编辑服务'
      this.editSure = true
      this.disabled = true
      let _this = this
      this.dialogFormVisible = true
      this.loopRule = [
        {
          add: true,
          strategy: [],
          priciRule: [],
          strategyName: '',
          strategyId: '',
          disabled: false,
          rule: '',
          ruleName: '',
          date: '',
          billArr: [
            {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
          ]
        }
      ]
      let getDetail = () => { // 请求详细信息
        return this.$axios({
          method: 'get',
          url: _this.$API.supplier.getSupServiceById,
          params: { id: val.supServiceId }
        })
      }
      let getStrategy = () => { // 请求计价策略
        return this.$axios({
          method: 'post',
          url: _this.$API.product.queryStrategyList
        })
      }
      this.$axios.all([getDetail(), getStrategy()])
        .then(_this.$axios.spread(function (detail, strategy) {
          // 两个请求现在都执行完成
          if (strategy.data && strategy.data.resData) {
            _this.loopRule[0].strategy = strategy.data.resData
          }
          if (detail.data && detail.data.resData) {
            console.log(detail.data)
            _this.form.sysName = detail.data.resData.sysName
            _this.form.sysId = detail.data.resData.sysId
            _this.form.supName = detail.data.resData.supName
            _this.form.supId = detail.data.resData.supId
            _this.form.shortName = detail.data.resData.supShortName
            _this.form.acctName = detail.data.resData.supAccountName
            _this.form.accId = detail.data.resData.supAccountId
            _this.form.cusName = detail.data.resData.supServiceName
            _this.form.cusEngName = detail.data.resData.supServiceEnName
            _this.form.cusTime = detail.data.resData.timeOut
            _this.form.cusPrice = detail.data.resData.supServiceGuidedPrice
            _this.form.cusAdress = detail.data.resData.supServiceUrl
            _this.form.cusTest = detail.data.resData.innerUrl
            _this.form.reqMethod = detail.data.resData.supServiceMethod + ''
            _this.form.cusState = detail.data.resData.state + ''
            if (!detail.data.resData.refList.length) return

            if (detail.data.resData.refList.length === 2) {
              let op = Object.assign({}, _this.loopRule[0]) // 计价信息长度为2，重新复制一个对象
              op.add = false
              _this.loopRule.push(op)
            }
            detail.data.resData.refList.forEach((v, i) => {
              let arr = []
              let num = 0 // 记录相匹配的次数
              if (v.refState === 1) {
                _this.entryTime = v.beginTime
              }
              detail.data.resData.refBillKeyWordsList.forEach((val, index) => {
                let obj = {
                  billKeyWord: '',
                  billParamName: '',
                  billKeyWordType: ''
                }
                if (v.supServiceChargeRefId === val.supServiceChargeRefId) {
                  obj.billKeyWord = val.billKeyWord
                  obj.billParamName = val.paramName
                  obj.billKeyWordType = val.billKeyWordType
                  num++
                  arr.push(obj)
                }
                if (index === detail.data.resData.refBillKeyWordsList.length - 1 && num === 0) {
                  arr.push(obj)
                }
              })
              if (!arr.length) {
                arr = [{
                  billKeyWord: '',
                  billParamName: '',
                  billKeyWordType: ''
                }]
              }
              if (v.strategyId === '20171020110707_Yr2r1x61_1000005') {
                arr = []
              }
              _this.loopRule[i].billArr = arr
              _this.loopRule[i].strategyName = v.strategyName
              _this.loopRule[i].strategyId = v.strategyId
              let ruleObj = {}
              ruleObj.ruleId = v.ruleId
              ruleObj.ruleNameCn = v.ruleName
              _this.loopRule[i].priciRule.push(ruleObj)
              _this.loopRule[i].rule = v.ruleId
              _this.loopRule[i].ruleName = v.ruleName
              _this.loopRule[i].date = v.beginTime
              if (v.refState === 1) {
                _this.loopRule[i].disabled = true
              }
            })
            console.log(_this.loopRule)
          }
        }))
    },
    detailSuper (index, row) { // 详情
      let _this = this
      this.$axios({
        method: 'get',
        url: this.$API.supplier.getSupServiceById,
        params: { id: row.supServiceId }
      }).then((reponse) => {
        console.log(reponse)
        let data = reponse.data.resData
        _this.detailInfo.sysName = data.sysName
        _this.detailInfo.supShortName = data.supShortName
        _this.detailInfo.timeOut = data.timeOut
        _this.detailInfo.supServiceUrl = data.supServiceUrl
        _this.detailInfo.supServiceMethod = data.supServiceMethod + ''
        _this.detailInfo.supServiceGuidedPrice = data.supServiceGuidedPrice
        _this.detailInfo.supServiceEnName = data.supServiceEnName
        _this.detailInfo.supName = data.supName
        _this.detailInfo.supServiceName = data.supServiceName
        _this.detailInfo.supAccountName = data.supAccountName
        _this.detailInfo.innerUrl = data.innerUrl
        _this.detailInfo.state = data.state + ''
        _this.detailData = [
          {
            strategy: [],
            priciRule: [],
            strategyName: '',
            ruleName: '',
            date: '',
            billArr: [
              {
                billKeyWord: '',
                billParamName: '',
                billKeyWordType: ''
              }
            ]
          }
        ]
        console.log(data)
        if (data.refList.length === 2) {
          let op = Object.assign({}, _this.detailData[0]) // 计价信息长度为2，重新复制一个对象
          _this.detailData.push(op)
        }
        data.refList.forEach((v, i) => {
          let arr = []
          let num = 0 // 记录相匹配的次数
          data.refBillKeyWordsList.forEach((val, index) => {
            let obj = {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
            if (v.supServiceChargeRefId === val.supServiceChargeRefId) {
              obj.billKeyWord = val.billKeyWord
              obj.billParamName = val.paramName
              obj.billKeyWordType = val.billKeyWordType
              num++
              arr.push(obj)
            }
            if (index === data.refBillKeyWordsList.length - 1 && num === 0 && data.refBillKeyWordsList.length) {
              arr.push(obj)
            }
          })
          if (!arr.length) {
            arr = [{
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }]
          }
          if (v.strategyId === '20171020110707_Yr2r1x61_1000005') {
            arr = []
          }
          console.log(_this.detailData[i])
          _this.detailData[i].billArr = arr
          _this.detailData[i].strategyName = v.strategyName
          _this.detailData[i].strategyId = v.strategyId
          let ruleObj = {}
          ruleObj.ruleId = v.ruleId
          ruleObj.ruleNameCn = v.ruleName
          _this.detailData[i].priciRule.push(ruleObj)
          _this.detailData[i].rule = v.ruleId
          _this.detailData[i].ruleName = v.ruleName
          _this.detailData[i].date = v.beginTime
          if (v.refState === 1) {
            _this.detailData[i].disabled = true
          }
        })
        console.log(_this.detailData)
        _this.detailDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    handleAdd () {
      let _this = this
      this.editSure = false
      this.dialogFormVisible = true
      this.title = '新增服务'
      this.disabled = false
      this.loopRule = [ // 每次新增清除之前数据
        {
          add: true,
          strategy: [],
          priciRule: [],
          strategyName: '',
          strategyId: '',
          disabled: false,
          rule: '',
          ruleName: '',
          date: '',
          billArr: [
            {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
          ]
        }
      ]
      let getSystem = () => { // 请求系统
        return this.$axios({
          method: 'post',
          url: _this.$API.apiList.querySysList,
          data: {'pageNum': 1, 'pageSize': 50}
        })
      }
      let getStrategy = () => { // 请求计价策略
        return this.$axios({
          method: 'post',
          url: _this.$API.product.queryStrategyList
        })
      }
      this.$axios.all([getSystem(), getStrategy()])
        .then(_this.$axios.spread((sys, strategy) => {
          if (strategy.data && strategy.data.resData) {
            _this.loopRule[0].strategy = strategy.data.resData
          }
          if (sys.data && sys.data.resData) {
            _this.form.busSystem = sys.data.resData
            console.log(_this.form.busSystem)
          }
        }))
    },
    close () {
      this.form = { // 关闭清除form
        cusState: '1',
        reqMethod: '1',
        cusTest: '',
        cusAdress: '',
        cusPrice: '',
        cusTime: '',
        cusEngName: '',
        cusName: '',
        acctName: '',
        shortName: '',
        sysName: '',
        supName: '',
        supId: '',
        accId: '',
        sysId: '',
        busSystem: [],
        supplier: [],
        account: [],
        supServiceChargeRefIdList: ''
      }
      this.entryTime = ''
      this.$refs['ruleForm'].resetFields() // 关闭时清除验证条件
    },
    changeFun (val) { // checkbox 选中时获取服务id
      this.supArr = []
      if (val.length) {
        for (let v of val) {
          this.supArr.push(v.supServiceId)
        }
      }
    },
    handleDelete (index, val) { // 单条删除
      let _this = this
      this.$confirm('此操作将永久删除该服务, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'get',
          url: _this.$API.supplier.deleteSupServiceInfo,
          params: { id: val.supServiceId }
        }).then((response) => {
          console.log(response)
          if (response.data.resCode === 1) {
            _this.$message.success('服务删除成功!')
            _this.query()
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    moreDelete () {
      if (!this.supArr.length) {
        this.$message.warning('请选择服务!')
        return
      }
      if (this.supArr.length > 1) {
        this.$message.warning('目前服务只支持单条删除!')
        return
      }
      this.handleDelete(0, { supServiceId: this.supArr[0] })
    },
    query () {
      let op = {}
      let id = this.formInline.value8
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage4
      op.pageSize = this.page
      op.createTimeStart = this.formInline.value1 ? this.formInline.value1[0] + ' 00:00:00' : null
      op.createTimeEnd = this.formInline.value1 ? this.formInline.value1[1] + ' 23:59:59' : null
      console.log(this.formInline.value1)
      op.sysIds = sysIds
      op.state = this.formInline.cusState ? this.formInline.cusState : -2
      op.supName = this.formInline.input
      op.supServiceName = this.formInline.cusInput
      // console.log(this.formInline)
      this.$store.dispatch('super/getTable', op)
      // this.$http({
      //   method: 'post',
      //   url: 'http://172.16.6.37:5010/agw/supServiceCtr/getSupServiceListByPage',
      //   data: op,
      //   dataType: 'json',
      //   contentType: 'application/json; charset=utf-8',
      //   headers: {'mtk': localStorage.getItem('usermtk')},
      //   crossDomain: true
      // }).then((response) => {
      //   console.log(response.data)
      //   this.tableData = response.data.resData.rows
      //   this.total = response.data.resData.total
      // }).catch((error) => {
      //   console.log(error)
      // })
    }
  },
  components: {
    Rule
  },
  created () {
    let _this = this
    let getUserAccount = () => {
      return _this.$axios({
        method: 'post',
        url: _this.$API.apiList.querySysList,
        data: { 'pageNum': 1, 'pageSize': 50 },
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: {'mtk': localStorage.getItem('usermtk')},
        crossDomain: true
      })
    }

    let getUserPermissions = () => {
      return this.$store.dispatch('super/getTable', { 'sysId': 0, 'state': -2, 'pageNum': 1, 'pageSize': 10 })
    }
    this.$axios.all([getUserAccount(), getUserPermissions()])
      .then(_this.$axios.spread(function (acct, perms) {
        // 两个请求现在都执行完成
        console.log(acct)
        console.log(_this.formInline)
        _this.formInline.options = acct.data.resData
      }))
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/supper/supperService.vue